const poolData = {
  UserPoolId: 'us-east-1_x2OYsF6g5',
  ClientId: '123',
  endpoint: 'https://www.dproz.com/auth',
};

export default poolData;